import { JsonProperty, Serializable } from "typescript-json-serializer";
@Serializable()
export class Vat{
    @JsonProperty()
    countryCode:string;
    @JsonProperty()
    vatId:string;
}